import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
/**
 * @description 跳转到指定锚点
 * @date 2022-02-15
 * @export
 */
export default function useAnchor() {
	const anchor = useHistory().location.hash;

	useEffect(() => {

		if (anchor && document.querySelector(anchor)) {
			setTimeout(() => {
				document.querySelector(anchor)!.scrollIntoView();
				// 为了解决滚动离开锚点，跳转链接后history.back()时，锚点还是会滚动到锚点位置的问题
				window.history.replaceState({}, '', window.location.pathname);
			}, 0)
		}
	}, [anchor])

}
